import { render, staticRenderFns } from "./CustomerOrderItem.vue?vue&type=template&id=643c7e23"
import script from "./CustomerOrderItem.vue?vue&type=script&lang=js"
export * from "./CustomerOrderItem.vue?vue&type=script&lang=js"
import style0 from "./CustomerOrderItem.vue?vue&type=style&index=0&id=643c7e23&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./locales.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2FUsers%2Fstv%2FPycharmProjects%2FcomponentDB%2Fvueapp%2Fsrc%2Fcomponents%2FBatchRun%2FCustomerOrder%2FCustomerOrderItem.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports